import { zodResolver } from '@hookform/resolvers/zod'
import * as Form from '../form'
import * as Stores from '../stores'
import { useCallback } from 'react'
import { ResolverError, ResolverOptions, ResolverSuccess } from 'react-hook-form'
import { z } from 'zod/v4'

const OfferCodeFormSchema = Form.CardApplicationFormSchema.pick({
  offerCode: true,
})

type OfferCodeFormValues = z.infer<typeof OfferCodeFormSchema>

export function useOfferCodeValidator() {
  const [validateOfferCode] =
    Stores.CardApplicationApi.endpoints['POST /card/onboarding/verifyOfferCode'].useMutation()

  return useCallback(
    async (
      dataToValidate: OfferCodeFormValues,
      context: unknown,
      options: ResolverOptions<OfferCodeFormValues>,
    ) => {
      const baseResolver = zodResolver(OfferCodeFormSchema)
      const baseResult = await baseResolver(dataToValidate, context, options)

      if (Object.keys(baseResult.errors).length > 0) {
        return baseResult
      }

      if (!dataToValidate.offerCode) {
        return {
          values: dataToValidate,
          errors: {},
        } satisfies ResolverSuccess<OfferCodeFormValues>
      }

      const result = await validateOfferCode({
        body: { offerCode: dataToValidate.offerCode },
      })

      if (result.data?.isValid) {
        return {
          values: dataToValidate,
          errors: {},
        } satisfies ResolverSuccess<OfferCodeFormValues>
      }
      return {
        values: {},
        errors: {
          offerCode: {
            message: result.data?.message ?? 'Please enter a valid code to proceed',
            type: 'required',
          },
        },
      } satisfies ResolverError<OfferCodeFormValues>
    },
    [validateOfferCode],
  )
}
